module.exports = __webpack_public_path__ + "/login_ui/img/tick-3013ed3dfb08894b61370fd66091fa7f.svg";